import { createAsyncThunk } from "@reduxjs/toolkit";
import { ShopCartUrlContext } from "../../../../common/utils/cart-util";
import { StoreState } from "../../../../store/store.interface";
import {
  addToGuestCartMagentoApiCall,
  removeGuestCartItemsMagentoApiCall,
} from "../api/shop-cart.api";
import { getGuestCartToken } from "../store/shop-cart.selectors";
import { getGuestCartTokenMagento } from "./get-guest-cart-token";

export const addGuestInstructorSampleToCart = createAsyncThunk(
  'shopCart/addGuestInstructorSampleToCart',
  async (shopCartUrlContext: ShopCartUrlContext, thunkAPI) => {
    try {
      let guestCartToken = getGuestCartToken(thunkAPI.getState() as StoreState);
      const hasExistingGuestCart = !!guestCartToken;

      if (!guestCartToken) {
        await thunkAPI.dispatch(getGuestCartTokenMagento({ forceUpdate: true }));
        guestCartToken = getGuestCartToken(thunkAPI.getState() as StoreState);
      }

      if (!guestCartToken) {
        throw new Error('magentoToken not defined');
      }

      if (!shopCartUrlContext.addProductMagentoRequest) {
        throw new Error('addProductMagentoRequest not defined');
      }

      if (hasExistingGuestCart) {
        await removeGuestCartItemsMagentoApiCall(guestCartToken);
      }

      await addToGuestCartMagentoApiCall(shopCartUrlContext, guestCartToken);

      return guestCartToken;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
